import React, { useEffect, useState } from 'react'
import ReCAPTCHA from "react-google-recaptcha";
import RegisterBg from './RegisterBg'
import './RegisterBg.css';
import styled from 'styled-components';
import { TextField } from '@mui/material';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore'
import { Link } from 'react-router-dom';
import { base, generateRandomNumbers, rKey } from '../utils';
import RegLoading from './RegLoading';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import PasswordIcon from '@mui/icons-material/Password';
import vt from '../media/mm_.jpeg'
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';


function Register({ ann }) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [width, setWidth] = useState(window.innerWidth);
    const [accTOU, setAccTOU] = useState(false)
    const [recaptchaToken, setRecaptchaToken] = useState(null);

    const [loading, setLoading] = useState(false)
    const [registerError, setRegisterError] = useState(false)
    const [checkBoxError, setCheckBoxError] = useState(false)

    const [noInput1, setNoInput1] = useState(false)
    const [noInput2, setNoInput2] = useState(false)
    const [noInput3, setNoInput3] = useState(false)



    useEffect(() => {
      const handleResize = () => {
        setWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
  
 
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);


    const createAccount = async (e) => {
      if(email !== '' && password !== '' && accTOU && recaptchaToken) {

          e.preventDefault();

          setLoading(true)
          setRegisterError(false)
          setCheckBoxError(false)

          setNoInput1(false)
          setNoInput2(false)
          setNoInput3(false)

          // Send the token to your server for verification
          const response = await fetch(`${base}/verify-recaptcha`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: recaptchaToken }),
          });

          const result = await response.json();

          if (result.success) {
            try {
              e.preventDefault()
              const userCredential = await createUserWithEmailAndPassword(auth, email.trim(), password.trim());
              const user = userCredential.user;

              // const actionCodeSettings = {
              //   url: 'https://marketlab.improwth.com',
              //   handleCodeInApp: true
              // };
              
              await sendEmailVerification(auth.currentUser)
  
              await setDoc(doc(db, 'users', user.uid), {
                  email: user.email,
                  prem: false,
                  active: true,
                  projects: [],
                  id: user.uid,
                  uCreatedAt: new Date().toUTCString(),
                  intr: false,
                  userPublicId: generateRandomNumbers(),
                  role: 'user',
                  nex: 20,
                  units: 0,
                  sid: null,
                  emailVerified: false,
                  welcomingEmail: false,
                  inuNot: false,
                  analytics: {
                    "toolsUsage": {
                        "low-quality-backlinks": 0,
                        "competition-research": 0,
                        "headers-test": 0,
                        "google-serp": 0,
                        "high-quality-backlinks": 0,
                        "indexed-pages": 0,
                        "domain-authority": 0,
                        "speed-test": 0,
                        "extract-meta-tags": 0,
                        "sitemaps": 0,
                        "keyword-research": 0,
                        "new-backlinks": 0,
                        "link-analysis": 0,
                        "top-referrers": 0,
                        "mobile-support-test": 0,
                        "top-search-queries": 0,
                        "page-authority": 0,
                        "crawlability-test": 0,
                        "keyword-density": 0,
                        "bing-serp": 0,
                        "content-ideation": 0,
                        "page-seo-health-test": 0
                    }
                }
              })
              
              window.location.href = '/'
         
          } catch (error) {
              e.preventDefault()
              // alert(error.message);
              setRegisterError(true)
              setLoading(false)
          }
          } else {
            alert('reCAPTCHA verification failed');
          }
      } else {
        // alert('Empty fields error!')
        if(!accTOU) {
          setCheckBoxError(true)
        } else {
          setRegisterError(true)
        }

        if(email.trim() === '') setNoInput1(true)
        if(password.trim() === '') setNoInput2(true)
        if(!recaptchaToken) setNoInput3(true)
        
        setLoading(false)
      }
    }


    const onChange = (token) => {
      setRecaptchaToken(token);
    }
    

    const styles = {
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'white', // Change border color
          },
          '&:hover fieldset': {
            borderColor: 'white', // Change border color on hover
          },
          '&.Mui-focused fieldset': {
            borderColor: 'white', // Change border color when focused
          },
        },
        '& .MuiInputBase-input::placeholder': {
          color: 'white', // Change placeholder color
        },
        '& .MuiFormLabel-root': {
          color: 'white', // Change label text color
        },
        input: {color: 'white', width: '300px'}
      }



  return (
    <div className='reg_box' style={{width: '100vw', height: '100vh', display: 'flex', flexDirection: 'row'}}>
        {width <= 768 && <RegisterBg style={{zIndex: '1000000'}}/>}

        {width > 768 && <Card>
            <h2>Create your account at <span>MarketLab</span></h2>

            {/* <TextField id="outlined-basic" label="Email" variant="outlined" sx={styles} type='email' onChange={e=> setEmail(e.target.value)}/>
            <TextField id="outlined-basic" label="Password" variant="outlined" sx={styles} type='password' onChange={e=> setPassword(e.target.value)}/> */}

            {registerError && <h4 className='error'><DisabledByDefaultIcon />Incorrect email or password!</h4>}
            {checkBoxError && <h4 className='error' style={{width: '70%'}}>Please accept the Terms of Use and Privacy Policy to proceed!</h4>}
            
            <div className='input_div' style={{borderColor: noInput1? 'red': ''}}>
              <AlternateEmailIcon />
              <input type='email' onChange={e=> setEmail(e.target.value)} placeholder='email'/>
            </div>

            <div className='input_div' style={{borderColor: noInput2? 'red': ''}}>
              <PasswordIcon />
              <input type='password' onChange={e=> setPassword(e.target.value)} placeholder='password'/>
            </div>

            <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px', width: '40%'}}>
            <input type='checkbox' checked={accTOU} onChange={e=> setAccTOU(e.target.checked)}/>
            <label>I accept the <a href='/terms-of-use' target="_blank">terms of use</a> and <a href='/privacy-policy' target="_blank">privacy policy</a></label>
            </div>

            <ReCAPTCHA
              sitekey={rKey}
              onChange={onChange}
            />
            {!recaptchaToken && noInput3 && <p style={{borderColor: noInput3? 'red': '', fontFamily: 'Quicksand', color: 'red'}}>Please verify you're not a robot by completing the CAPTCHA</p>}

            {!loading && <button onClick={e=> createAccount(e)}>Create Account</button>}

            {!loading && <p>Already have an account? <Link to='/login' style={{textDecoration: 'none', color: 'white'}}><span>Log in</span></Link></p>}
        
            {loading && <RegLoading />}
        </Card>}


        {width > 768 && <div style={{display: 'flex', flexDirection: 'column', width: '50%', color: 'white', height: '100%', zIndex: '100', justifyContent: 'center', alignItems: 'center'}}>
          <h2 style={{marginTop: '160px', fontFamily: 'Quicksand', fontWeight: 'normal', width: '600px', color: 'white', fontSize: 'larger'}}>MarketLab v5 Update: New Features and System Enhancements</h2>
          <h5 style={{fontFamily: 'Quicksand', fontWeight: 'normal', width: '600px', color: 'dodgerblue', fontSize: 'larger', marginBottom: '20px'}}>Michael Montague</h5>
          
          <video controls width="600px" poster={vt} style={{borderRadius: '3px'}}>
            <source src='https://firebasestorage.googleapis.com/v0/b/market-lab-2ed93.appspot.com/o/media%2Fml_v5.mp4?alt=media&token=aa7e66d2-6485-47ba-bc26-013553e2b090' type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
            <p style={{marginLeft: '20px', marginBottom: '20px', textAlign: 'center', width: '375px', backgroundColor: 'rgba(0, 0, 0, 0.4)', padding: '10px', borderRadius: '3px', marginTop: 'auto', fontFamily: 'Quicksand'}}>{ann}</p>
        </div>}

        {width <= 768 && 
        <div style={{display: 'flex', flexDirection: 'column', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
          <h2 style={{fontWeight: '300', fontFamily: 'Crimson Text', marginBottom: '10px', color: 'lightgray', width: '75%'}}>Welcome to Market Lab!</h2>
          <p style={{color: 'white', width: '75%'}}>The application is currently available only on desktop. Mobile support is coming soon! Please visit us on your desktop for now. 
          Thanks for your understanding.
          </p>
        </div>
        }
    </div>
  )
}

export default Register

const Card = styled.div`
    /* position: absolute;
    top: 50%;
    left: 50%; */
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    /* background-color: rgba(255, 255, 255, 0.10); */
    background-color: #19191976;
    filter: blur(95%);
    color: white;
    /* transform: translate(-50%, -50%); */
    gap: 25px;
    z-index: 1000;

    > .input_div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      background-color: #191919;
      border: 1px solid black;
      padding: 3px 6px;
      width: 290px;
      border-radius: 2px;


      > input {
        font-family: 'Quicksand';
        padding: 4px;
        border: none;
        border-radius: 2px;
        outline: none;
        background-color: transparent;
        color: white;
        height: 25px;
        width: 100%;
      }

      > .MuiSvgIcon-root {
        color: white;
      }
    }

    > h2 {
        color: white;
        font-weight: 300;

        > span {
          font-family: 'Crimson Text';
          font-size: 37px;
        }
    }


    > button {
        background-color: white;
        color: black;
        border: 1px solid gray;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        border-radius: 3px;
        margin-top: 25px;
        padding: 5px 10px;
        width: 300px;
        cursor: pointer;

        transition: background-color 0.3s ease-in-out;
    }

    > button:hover {
        background-color: black;
        color: white;
    }

    > p {
      color: white;
      font-size: 13px;
      margin-top: 20px;
    }

    > p > span {
      color: dodgerblue;
      cursor: pointer;
    }

    > p > span:hover {
      color: lightgray;
    }

    > div > label {
      font-size: 14px;
    }

    > div > label > a {
      text-decoration: none;
      color: dodgerblue;
    }

    > .error {
      font-family: 'Quicksand';
      font-weight: 400;
      padding: 10px;
      background-color: transparent;
      color: red;
      border-radius: 3px;
      width: 60%;
      border-color: red;
      border: 1px solid;
      display: flex;
      align-items: center;
      gap: 5px;
    }
`